import { Box, Stack } from '@mui/material'
import React from 'react'
import { css, keyframes } from "@emotion/react";

import { Color, FontStyle } from '../constants'

const tease = () => keyframes`
    0% {
        transform: scale(1);
    }
    10% {
        transform: scale(1.025);
    }
    100% {
        transform: scale(1);
    }
`;
const styles = {
    container: {
        // backgroundColor: Color.primary,
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '0.75rem',
        padding: '0.58rem 0.75rem',
        // margin: '0.48rem 0.48rem 0px 0px',
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: 'center',
        width: 'fit-content',
        backgroundColor: 'white',
        '&:hover': {
            animation: `${tease()} 0.3s ease-in-out 0s`,
        },
    },
    selected: {
        backgroundColor: Color.primary,
    },
    text: {
        ...FontStyle.body,
        fontSize: '16px',
        transition: 'all 0.3s ease-in-out 0s',
        // transform: 'translateX(-0.7rem)',
    },
    icon: {
        position: 'absolute',
        left: '0.75rem',
        transition: 'all 0.3s cubic-bezier(0.8, 1.64, 0.6, 1) 0s',
        opacity: 0,
        transform: 'translateY(-50%)'
    },
    iconSelected: {
        opacity: 1,
        transform: 'scale(1)',
    },
}

const SimpleButton = ({ text, selected, setSelected }) => {
    return (
        <Stack direction='row' sx={{ ...styles.container, ...(selected && styles.selected) }} onClick={() => setSelected(!selected)}>
            <Box sx={{ ...styles.text }}>
                {text}</Box>
        </Stack>
    )
}

export default SimpleButton